module.exports = __webpack_public_path__ + "img/gb9122_2_p.prt.eda3f35e.jpg";